import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const reportAProblemTemplate = htmlE`
  <textarea
    id="reportAProblemTextArea"
    class="textarea w-full"
    rows="6"></textarea>
`;

export default reportAProblemTemplate;
